import { INVESTOR_OBJECT, INVETSOR_DETAILS_RESPONSE } from '../../redux-store/types/nct';
import { NFT_TRXN_MAP_TYPE_VALUES, NFT_TRXN_TYPE_MAP, TRXN_MAP_TYPE_VALUES } from '../dashboard/commercial/utils';
import { PanSeedCheckRequestDataType } from './types';

export const MESSAGE_MAP: { [key: string]: string } = {
    'Not allowed': 'Your KYC is not compliant. Please check with your respective KRA',
    'Not reachable':
        'We are unable to connect with respective KRA server to verify KYC status for your PAN. Please try again after sometime.',
};

export const NOT_VERIFIED = 'Not verified';

export const kycNotVerified = (message: string) => {
    const NOT_VERIFIED_MESSAGES = ['Not allowed', 'Not reachable'];
    return NOT_VERIFIED_MESSAGES.filter((msg) => msg === message).length > 0;
};


export const getRandomPanSeedCheckFolio = (
    folios: Array<INVESTOR_OBJECT & { fund?: string } & {id?: string}>,
    trxnType: NFT_TRXN_MAP_TYPE_VALUES  | TRXN_MAP_TYPE_VALUES,
    trxnMode: 'NFT' | 'FT'
): PanSeedCheckRequestDataType => {
    const randomFolio = getRandomItem(folios);
    // ternary operator is not readable
    const getfolio = () => {
        if (randomFolio.folio) {
            return String(randomFolio.folio);
        }
        if (trxnType === NFT_TRXN_TYPE_MAP.updateBankIFSC) {
            return String(randomFolio.id);
        }
        return '';
    } 
    return {
        taxStatus: randomFolio.taxStatus || '' ,
        folio: getfolio(),
        trxnMode,
        amc: randomFolio?.amc || randomFolio?.fund || '',
        invDob: '',
        invName: '',
        trxnType,
    };
};

export const getRandomItem = <T>(arr: T[]): T => {
    const randomIndex = Math.floor(Math.random() * arr.length);
    const randomItem = arr[randomIndex];
    return randomItem;
};
